export default {
	articleEditDialog: {
		title: "Article {articleId} - Paramètres",
		articleNameLabel: "Nom de l'article",
		articleNumberLabel: "Numéro d'article",
		articleNumberPlaceholder: "Votre numéro d'article",
		articleNumberHint:
			"Vous pouvez attribuer à chaque article son propre numéro d'article. Ce numéro apparaît également sur le bon de livraison et la facture.",
		materialLabel: "Matériau",
		deburringLabel: "Ébavurage :",
		migratedHint: "Blexonisez l'article pour modifier l'ébavurage.",
		deburringPlaceholder: "Veuillez choisir un type d'ébavurage...",
		werkstoffChangedHint:
			"Si le matériau doit être modifié, l'article doit d'abord être recalculé avant que le type d'ébavurage puisse être ajusté. Pour cela, enregistrez les modifications actuelles et attendez que l'article soit validé.",
		deburringInfoTooltip: "Informations sur l'ébavurage des pièces métalliques",
		close: "Fermer",
		saveMaterialTooltip: "Enregistre le matériau.",
		saveArticleTooltip: "Enregistre l'article avec les données indiquées.",
		saveFailedError: "Les données n'ont pas pu être enregistrées. {error}",
		saveMaterialFailedError: "Le matériau n'a pas pu être modifié. {error}",
	},
	articleDeleteWarningDialog: {
		title: "Attention !",
		inCartsText: "L'article sera également supprimé des listes de pièces suivantes :",
		confirmDelete: "Voulez-vous vraiment supprimer cet article ?",
		weldedText:
			"Cet article ne peut pas être supprimé, car il est soudé à d'autres articles de cet assemblage.",
		delete: "Supprimer",
		messages: {
			deleteError: "L'article n'a pas pu être supprimé.",
		},
	},
	articleMultiDeleteDialog: {
		title: "Supprimer plusieurs articles",
		deletedProgress: "{deleted} sur {total} supprimés",
		lockedArticlesText:
			"Les articles suivants sont soit verrouillés, soit en cours de calcul, et ne peuvent donc {not} être supprimés :",
		lockedArticlesTextBold: "pas",
		partOfCartsText: "Les articles suivants font partie d'au moins une liste de pièces :",
		containedIn: "Contenu dans...",
		confirmDeleteCount: "Voulez-vous vraiment supprimer {count} articles ?",
		noneCanBeDeleted: "Aucun des articles sélectionnés ne peut être supprimé.",
		delete: "Supprimer",
		messages: {
			deleteError: "Erreur lors de la suppression d'un article.",
		},
	},
	articlePriceInfoDialog: {
		title: "Vous trouverez le prix final, remise de quantité incluse, dans le panier.",
		intro:
			"La liste de prix permet aux concepteurs d'obtenir rapidement une estimation de prix et s'applique à la commande de cet article unique (en quantité homogène).",
		explanation:
			"Pour calculer le prix final, veuillez composer un panier et obtenir en quelques secondes une offre incluant le délai de livraison.",
		discountExplanation:
			"Lors du calcul de l'offre, tous les articles inclus sont pris en compte et une remise spécifique à la commande (remise de commande) est calculée.",
		discountHighlight:
			"Plusieurs articles avec les mêmes usinages ou le même matériau entraînent une réduction de prix.",
		factorsIntro: "Les facteurs suivants entraînent une {reduction}",
		factorsReductionBold: "réduction de prix :",
		factor1: "Plusieurs articles issus du même matériau brut (même matériau et même épaisseur de tôle)",
		factor2:
			"Plusieurs articles avec les mêmes usinages (taraudages, fraisages coniques et emboutis) dans le même matériau brut",
		factor3: "Plusieurs articles avec le même thermolaquage (même poudre)",
		factor4: "Plusieurs articles avec la même galvanisation",
		priceNote:
			"Le prix s'entend hors TVA, remises spécifiques à la commande, emballage et livraison.",
		close: "Fermer",
	},
	articleTreatmentEditDialog: {
		closeTooltip: "Ferme la boîte de dialogue.",
		notAvailableTitle: "Thermolaquage",
		notAvailableText: "Le thermolaquage des articles n'est malheureusement pas encore disponible dans votre région.",
		titleSingle: "Thermolaquage - Article '{name}' ({id})",
		titleMultiple: "Thermolaquage - {count} articles",
		standardColorsHint: "Seules les couleurs standard sans supplément sont affichées.",
		showAllColorsLabel: "Afficher toutes les couleurs",
		ralSearchLabel: "Rechercher une couleur RAL",
		structureLabel: "Structure",
		finishLabel: "Finition",
		powderSelectionHeading: "Sélection de la poudre :",
		standardNoSurchargeSuffix: " (Standard sans supplément)",
		noPowderAvailable: "Aucune poudre disponible avec le filtre actuel",
		nonStandardPowderInfo1: "Cette poudre ne fait pas partie de l'assortiment standard et doit être commandée.",
		nonStandardPowderInfo2:
			"Un supplément unique de {cost} est appliqué. En cas de plusieurs positions dans cette couleur, le supplément n'est facturé qu'une seule fois, étant pris en compte dans la remise de commande.",
		nonStandardPowderInfo3:
			"Veuillez noter que cela peut également entraîner un allongement des délais de livraison.",
		faceLabel: "Surface",
		baseCoatingLabel: "Pré-primaire : offre une protection anticorrosion",
		warningText1:
			"Pour le thermolaquage, il faut compter avec une {thickness}. Concevez en conséquence les perçages et découpes éventuels plus grands. Les {gewinde} sont masqués avant le revêtement et ne doivent pas être adaptés. Les {senkungen} ne sont pas masqués, mais l'épaisseur de la couche est compensée lors de la fabrication.",
		warningThicknessBold: "épaisseur de couche d'env. 0,1 mm",
		warningGewindeBold: "taraudages",
		warningSenkungenBold: "fraisages coniques",
		warningTextOneSided:
			"Il faut également tenir compte du fait qu'en cas de revêtement unilatéral, le côté opposé n'est pas masqué et qu'il faut donc s'attendre à un {spray} de ce côté.",
		warningSprayBold: "brouillard de pulvérisation",
		warningText2:
			"{achtung} Le thermolaquage seul n'offre {noCorrosion}. Les {steelParts} thermolaquées ne sont donc {notOutdoor}, sauf si un {primer} est réalisé. Il s'agit d'un revêtement supplémentaire qui offre une protection anticorrosion aux pièces en acier. Les pièces thermolaquées en acier inoxydable ou en aluminium conviennent pour une utilisation extérieure ou des lieux à forte humidité, à condition qu'il n'y ait pas de conditions environnementales extrêmes. En cas de conditions climatiques extrêmes et dans des environnements à forte humidité et à forte teneur en sel dans l'air, un pré-primaire devrait également être choisi pour l'aluminium. Pour toute question ou incertitude, n'hésitez pas à contacter notre support.",
		warningAchtungBold: "Attention :",
		warningNoCorrosionBold: "aucune protection anticorrosion",
		warningSteelPartsBold: "pièces en acier",
		warningNotOutdoorBold: "pas adaptées à une utilisation extérieure ou à des lieux à forte humidité",
		warningPrimerBold: "pré-primaire",
		close: "Fermer",
		removeTooltipSingle: "Retire le thermolaquage de l'article.",
		removeTooltipMultiple: "Retire le thermolaquage de tous les articles.",
		removeButton: "Retirer",
		saveTooltipSingle: "Enregistre le thermolaquage.",
		saveTooltipMultiple: "Enregistre le thermolaquage pour tous les articles.",
		finishOptions: {
			all: "Toutes",
			matt: "Mat",
			glossy: "Brillant",
		},
		structureOptions: {
			all: "Toutes",
			smooth: "Lisse",
			fine: "Fine",
			rough: "Grossière",
		},
		faceOptions: {
			top: "Face supérieure",
			bottom: "Face inférieure",
			both: "Des deux côtés",
		},
		messages: {
			loadPowdersError: "Les poudres n'ont pas pu être chargées.",
			loadMaterialIdsError: "Les identifiants de matériau n'ont pas pu être chargés.",
			saveError: "Le traitement de surface de l'article {articleId} n'a pas pu être enregistré.",
			saveSuccess: "Le traitement de surface a été enregistré.",
			deleteError: "Le traitement de surface de l'article {articleId} n'a pas pu être supprimé.",
			deleteSuccess: "Le traitement de surface a été supprimé.",
		},
	},
	articleZincCoatingEditDialog: {
		analyzingTitle: "Analyse de la galvanisation en cours...",
		close: "Fermer",
		titleSingle: "Galvanisation - Article '{name}' ({id})",
		titleMultiple: "Galvanisation - {count} articles",
		errorIntroSingle: "Une galvanisation n'est pas possible pour cet article pour la raison suivante :",
		errorIntroMultiple: "Une galvanisation n'est pas possible pour les articles listés :",
		hotDipLabel: "Galvanisation à chaud",
		thicknessLabel: "Épaisseur de couche : ",
		hotDipThicknessValue: "50-150µm",
		galvanizeThicknessValue: "5-20µm",
		moreInfo: "Plus d'informations",
		hotDipInfoText:
			"Lors de la galvanisation à chaud, les pièces sont plongées dans un bain de zinc à une température d'environ 450 °C. Cette température élevée génère des tensions dans les pièces. C'est pourquoi une conception adaptée des pièces à galvaniser est très importante. Pour les pièces fermées (par ex. des caissons soudés), des ouvertures doivent être prévues. Elles permettent, d'une part, à l'air qui se dilate sous l'effet de la chaleur de s'échapper et, d'autre part, à l'excédent de zinc de s'écouler lors du retrait du bain. De plus, les tôles minces (épaisseur < 4 mm) ne conviennent généralement pas à la galvanisation à chaud, car elles peuvent fortement se déformer sous l'effet de la chaleur.",
		hotDipNotPossibleSingle: "La galvanisation à chaud n'est pas disponible pour ce matériau.",
		assemblyHint:
			"Les assemblages ne peuvent être galvanisés que si tous les sous-articles autorisent ce type de galvanisation.",
		hotDipNotPossibleMultiple:
			"La galvanisation à chaud n'est pas disponible pour cette combinaison de matériaux. Essayez de galvaniser les articles individuellement.",
		hotDipPowderCoatedConflict:
			"Blexon ne propose actuellement pas la combinaison galvanisation à chaud et thermolaquage.",
		threadsNotHotDippable: "Les articles avec taraudages ou emboutis ne peuvent pas être galvanisés à chaud.",
		galvanizeLabel: "Galvanisation électrolytique",
		galvanizeInfoText:
			"Contrairement à la galvanisation à chaud, les pièces ne sont pas plongées dans un bain de zinc en fusion lors de la galvanisation électrolytique, mais dans un électrolyte de zinc. Un élément de zinc sert alors d'anode et la pièce en acier à revêtir de cathode. Ce procédé génère moins de chaleur et convient donc aux tôles plus fines. Pour les applications extérieures durables, l'épaisseur de la couche de zinc est cependant souvent trop fine.",
		galvanizeNotPossibleSingle: "La galvanisation électrolytique n'est pas disponible pour ce matériau.",
		galvanizeNotPossibleMultiple:
			"La galvanisation électrolytique n'est pas disponible pour cette combinaison de matériaux. Essayez de galvaniser les articles individuellement.",
		sendToHelpdesk: "Envoyer au support",
		removeTooltipSingle: "Retire la galvanisation de l'article.",
		removeTooltipMultiple: "Retire la galvanisation de tous les articles.",
		removeButton: "Retirer",
		saveTooltipSingle: "Enregistre la galvanisation.",
		saveTooltipMultiple: "Enregistre la galvanisation pour tous les articles.",
		messages: {
			loadError: "Les données de galvanisation n'ont pas pu être chargées.",
			saveError: "La galvanisation de l'article {articleId} n'a pas pu être enregistrée.",
			saveSuccess: "La galvanisation a été enregistrée.",
		},
	},
	certificateHelperDialog: {
		title: "Certificat / Attestations",
		text1:
			"Après la livraison des pièces, vous pouvez télécharger un certificat de réception 3.1 selon EN 10204:2004 dans vos archives de commandes.",
		text2: "L'attestation provient du fabricant de la matière première et ne comprend pas d'attestation de retranscription par le transformateur de tôle.",
		close: "Fermer",
	},
	isPowdercoatingPossibleDialog: {
		analyzingTitle: "Analyse du thermolaquage en cours...",
		notPossibleTitle: "Thermolaquage non sélectionnable",
		possibleTitle: "Thermolaquage possible",
		reasonIntroSingle: "Un thermolaquage n'est pas possible pour cet article pour la raison suivante :",
		reasonIntroMultiple: "Un thermolaquage n'est pas possible pour les articles listés :",
		sendToHelpdesk: "Envoyer au support",
		close: "Fermer",
		messages: {
			determineError: "Il n'a pas été possible de déterminer si l'article peut être thermolaqué.",
		},
	},
	sendToHelpdeskDialog: {
		title: "Envoyer l'article au support Blexon",
		text1:
			"Vous envoyez cet article au support Blexon. Nous examinerons la cause des messages d'erreur et la corrigerons si possible. Nous serons également heureux de vous donner des indications sur la manière de modifier la conception afin que l'article devienne réalisable.",
		freeService: "Ce service est gratuit.",
		text2:
			"Vous serez informé par e-mail dès que l'article aura été traité. La vérification a lieu pendant les heures ouvrables, généralement dans un délai de quelques heures.",
		text3:
			"Veuillez noter qu'après l'envoi, l'article ne peut plus être modifié ni supprimé jusqu'à ce qu'il soit validé par Blexon.",
		emailLabel: "E-mail pour les notifications concernant cet article",
		sendButton: "Envoyer",
		sendTooltip: "Envoie l'article au support pour clarification.",
		abortDialogTitle: "Ne pas envoyer l'article",
		abortDialogText:
			"Voulez-vous vraiment annuler cette action ? L'article ne sera pas transmis au support Blexon.",
		abortConfirmButton: "Ne pas envoyer",
		abortConfirmTooltip: "Annule l'action sans envoyer l'article au support.",
		messages: {
			sendSuccess: "L'article a été envoyé au support.",
			sendError: "L'article n'a pas pu être envoyé au support. Veuillez contacter info@blexon.com.",
		},
	},
	tooManyCalculatingDialog: {
		title: "Trop de calculs simultanés",
		text1: "Vous pouvez blexoniser jusqu'à 10 articles simultanément.",
		text2:
			"Les calculs sont très gourmands en temps et en ressources. C'est pourquoi nous limitons le nombre de calculs simultanés afin de protéger nos serveurs et de répartir les performances équitablement entre tous les clients.",
		text3: "Veuillez patienter jusqu'à ce que certains calculs soient terminés. Merci de votre compréhension.",
		close: "Fermer",
	},
	speechBubbleFloat: {
		dontShowAgain: "Ne plus afficher ce message",
	},
};
